import React from 'react';
import { compose } from 'recompose';
import {
    autoCompleteDefaultLifeCycle,
    autoCompletePickerPropTypes,
    autoCompleteWithHandlerLoadData,
    autoCompleteWithHandlers,
    autoCompleteWithStateHandlers,
} from '../helpers/autoComplete';
import { fetchAllTeams as apiFetchAllTeams } from '../../../../front-v2/services/api';

const autoCompleteTeamHOC = AutoComplete =>
    compose(
        autoCompletePickerPropTypes(),
        autoCompleteWithStateHandlers(),
        autoCompleteWithHandlerLoadData(apiFetchAllTeams, 300),
        autoCompleteWithHandlers({}, false),
        autoCompleteDefaultLifeCycle(true),
    )(props => <AutoComplete {...props} />);

export default autoCompleteTeamHOC;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/hoc/autoCompleteTeamHOC.js
 **/